import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import stethoscope from "../../images/folders.svg";
import useUserState from "../hooks/useUserState";
import Axios from "axios";
import HealthMeasurementDialog from "./HealthMeasurementDialog";
import useBDocTranslator from "../hooks/useBDocTranslator";
import EHRFilesDialog from "./EHRFilesDialog";
import Loading from "react-loading";
import useUploadEHRFiles from "../hooks/useUploadEHRFiles";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
    padding: theme.spacing(4),
    width: "90%",
    maxWidth: 720,
    maxHeight: "90vh",
    overflowY: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& img": {
      width: 32,
      height: 32,
      marginRight: theme.spacing(1.5),
    },
    "& h3": {
      margin: 0,
      fontSize: "1.125rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
}));

export default function EHRFilesModalForm(props) {
  const classes = useStyles();
  const { t } = useBDocTranslator();

  const {
    responseMessage,
    handleUploadEHRFile,
    successFlag,
    setUploadedFiles,
    loading,
    uploadedFiles,
  } = useUploadEHRFiles(props.patientId, props.handleRefreshData);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {
            <div className={classes.paper}>
              <div className={classes.header}>
                <img src={stethoscope} alt="files icon" />
                <h3>{t("Appointment Files")}</h3>
              </div>
              {loading && (
                <div className="text-center" style={{ marginBottom: "12px" }}>
                  <Loading type="spin" color="#387ADF" height={50} width={50} />
                </div>
              )}
              {responseMessage && (
                <p
                  className={`font-weight-bold text-center ${
                    responseMessage.includes("Error") ? "text-danger" : "text-success"
                  }`}
                  style={{ marginBottom: "12px" }}
                >
                  {t(responseMessage)}
                </p>
              )}
              {/* Form */}
              <div style={{ marginTop: "8px" }}>
                <EHRFilesDialog
                  handleUploadEHRFile={handleUploadEHRFile}
                  handleClose={props.handleClose}
                  successFlag={successFlag}
                  patientId={props.patientId}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  loading={loading}
                />
              </div>
            </div>
          }
        </Fade>
      </Modal>
    </div>
  );
}
